export default __webpack_public_path__ + "static/media/apvs-material-6.f71bed8d.webp";